import type { FormApplication, FormApplicationExportColumn } from "../_types/formsApplications.types";

const formatFormExportTimestamp = (timestamp: number | null) =>
  timestamp === null ? "" : new Date(timestamp).toISOString();

export const FORM_APPLICATION_EXPORT_COLUMNS: Array<FormApplicationExportColumn> = [
  {
    key: "type",
    label: "Type",
    defaultSelected: true,
  },
  {
    key: "fullName",
    label: "Full name",
    defaultSelected: true,
  },
  {
    key: "email",
    label: "Email",
    defaultSelected: true,
  },
  {
    key: "phone",
    label: "Phone",
    defaultSelected: true,
  },
  {
    key: "company",
    label: "Company",
    defaultSelected: true,
  },
  {
    key: "content",
    label: "Message",
    defaultSelected: true,
  },
  {
    key: "id",
    label: "Application ID",
  },
  {
    key: "read",
    label: "Read",
    getValue: (application) => String(application.read),
  },
  {
    key: "createdAt",
    label: "Submitted at",
    getValue: (application) => formatFormExportTimestamp(application.createdAt),
  },
  {
    key: "readByUserId",
    label: "Read by user ID",
  },
  {
    key: "readByName",
    label: "Read by name",
  },
  {
    key: "readAt",
    label: "Read at",
    getValue: (application) => formatFormExportTimestamp(application.readAt),
  },
];

export const getFormApplicationExportColumnValue = (
  application: FormApplication,
  column: FormApplicationExportColumn
) => (column.getValue ? column.getValue(application) : application[column.key]);
